import './App.css';



function App() {
  var QCELLProp = {
    id  : 'qcell',
    parentid    : 'sheetarea1',
    data    : {'input': [{"name":"Hello","message":"큐셀!","etc":"가장 간단한 첫번째 큐셀 그리드입니다."}]},
    columns :  [
        {key: 'name', type:'input', title: ['컬럼1'], width: "20%"}
        , {key: 'message', title: ['컬럼2'], width: "30%"}
        , {key: 'etc', title: ['컬럼3'], width: "50%"}
     ]
    };

    setTimeout(function(){
      window.QCELL.create(QCELLProp);
    });


    function fnCustomPhone(data) {
      var nData = '';
      if(data.startsWith("010")){
        nData = data.substr(0, 3)+'-'+data.substr(3, 4)+'-'+data.substr(7, data.length);
      } else {
        if(data.legnth === 11){
          nData = data.substr(0, 3)+'-'+data.substr(3, 4)+'-'+data.substr(7, data.length);
        } else {
          if(data.startsWith("02")){
            nData = data.substr(0, 2);
            if(data.substr(2, data.length).length == 8){
              nData += '-'+data.substr(2, 4)+'-'+data.substr(6, data.length); 
            } else {
              nData += '-'+data.substr(2, 3)+'-'+data.substr(5, data.length);
            }
          } else {
            nData = data.substr(0, 3);
            if(data.substr(3, data.length).length == 8){
              nData += '-'+data.substr(3, 4)+'-'+data.substr(7, data.length); 
            } else {
              nData += '-'+data.substr(3, 3)+'-'+data.substr(6, data.length);
            }
          }
        }
      }
      return nData;
    }  
             // var sampleData = [{"name":"Hello","message":"큐셀!","etc":"가장 간단한 큐셀 그리드입니다."}];  
             function fnCustomIdNum(data) {
      var nData = '';
      nData = data.substr(0, 6) + "-" + data.substr(6, 1) + "XXXXXX"; 
      return nData;
    }
    
    // 사업자 번호 자릿수에 맞춰 '-' 처리
    function fnCustomBuzNum(data) {
      var nData = '';
      nData = data.substr(0, 3) + "-" + data.substr(3, 2) + "-" + data.substr(5, data.length);
      return nData;
    }
    
    // 카드번호 뒷자리 8문자 'X' 처리
    function fnCustomCardNum(data) {
      var nData = '';
      nData = data.substr(0, 4) + "-" + data.substr(4, 4) + "-XXXX-XXXX";
      return nData;
    }
    
    // 구 우편번호 자릿수에 맞춰 '-' 처리
    function fnCustomZipNum(data) {
      var nData = '';
      nData = data.substr(0, 3) + "-" + data.substr(3 , data.length);
      return nData;
    } 

    function fnClick(e){
      console.log('fnClick');
      console.log(e);
    }
    
    function fnValuechanged(e){	
      var col = window.QCELL.getInstance('qcell4').getIdx("col");
      if(col === 6) { // 컬럼타이틀 input 이 변경될 때만 화면 갱신
        window.QCELL.getInstance('qcell4').refresh();
      }
    }
    
    function imageclick(){
      alert('imageclick');
    }
    
    function customIden(data){
      var data_1st = data.substr(0, 6);
      var data_2nd = data.substr(6, 1);
      
      return data_1st +"-"+ data_2nd +"XXXXXX";
    }
    
    function fnRenderer(id, row, col, val, obj){
      var first, second;
      
      switch(Math.floor(val)){
        case 1: first = "1"; second = findSecond(val, first); break;
        case 2: first = "2"; second = findSecond(val, first); break;
        case 3: first = "3"; second = findSecond(val, first); break;
        case 4: first = "4"; second = findSecond(val, first); break;
        case 5: first = "5"; second = findSecond(val, first); break;
        default: first = "0"; second = findSecond(val, first); break;
      }
      var imgFull = "<img src=\"/images/rating/star_"+first+second+".png\">";
      if(val === 0){
        imgFull = "";
      } else if(first === "0" && second === "") {
        imgFull = "";
      }
      return imgFull;
    }
    
    function findSecond(val, first){
      var std = val-Number(first);
      var str = "";
      if(std == 0) {
        str = "";
      }
      else {
        if(Math.round(std) == 1) {
          str = "H";
        }
        else {
          str = "";
        }
      }
      return str;
    }
    
    // rederer 기능을 이용, 단위 10억 달러에 대한 표시 billion 강조
    function fnGdp(id, row, col, val, obj){
      var str = '',
      html = "<span style='color: blue;'>(billion)</span>";
      str += val + " " + html;
      return str;
    }
    
    //rederer 기능을 이용, 단위 10억 달러에 대한 표시 billion 강조
    function fnGdp_ppp(id, row, col, val, obj){
      var str = '',
      html = "<span style='color: blue;'>(billion)</span>";
      str += val + " " + html;
      return str;
    }     

    var data2=[{"index":0,"name":"전지현","salary":"9,218","phone":"0332915473","id_num":"9412284432332","buz_num":"5776336586","card_num":"3300859548194977","old_zipcode":"473850"},{"index":1,"name":"강남길","salary":"8,781","phone":"05312413205","id_num":"8006097292336","buz_num":"6707275085","card_num":"3572622146441283","old_zipcode":"644306"},{"index":2,"name":"고수","salary":"7,904","phone":"06317162077","id_num":"9412048692074","buz_num":"1511112056","card_num":"1151618626344990","old_zipcode":"600846"},{"index":3,"name":"한가인","salary":"4,374","phone":"06249616596","id_num":"9006269861501","buz_num":"3431011170","card_num":"7657868466824703","old_zipcode":"444747"},{"index":4,"name":"공유","salary":"2,580","phone":"05585154284","id_num":"9006266362927","buz_num":"3606286199","card_num":"2891385910696542","old_zipcode":"797982"},{"index":5,"name":"한효주","salary":"8,008","phone":"03381325732","id_num":"7912164292122","buz_num":"2081273834","card_num":"5339637562096653","old_zipcode":"154195"},{"index":6,"name":"김갑수","salary":"7,519","phone":"03220977021","id_num":"8503077766476","buz_num":"4491934984","card_num":"4317429850652122","old_zipcode":"707646"},{"index":7,"name":"한석규","salary":"1,192","phone":"0218994334","id_num":"7311163284056","buz_num":"9106644292","card_num":"6448661096364653","old_zipcode":"983943"},{"index":8,"name":"황정민","salary":"4,711","phone":"04436742976","id_num":"7912128030880","buz_num":"2224248802","card_num":"5159739520724330","old_zipcode":"162569"},{"index":9,"name":"송중기","salary":"343","phone":"05235976892","id_num":"6606091887459","buz_num":"8074290817","card_num":"2404408186562783","old_zipcode":"641656"},{"index":10,"name":"차인표","salary":"5,806","phone":"05438728349","id_num":"7906012873181","buz_num":"2878681044","card_num":"4716781396457572","old_zipcode":"946888"},{"index":11,"name":"김태희","salary":"9,708","phone":"05487459998","id_num":"7311071204729","buz_num":"5016555109","card_num":"2648239672061404","old_zipcode":"144478"},{"index":12,"name":"김진수","salary":"9,033","phone":"06345509643","id_num":"8310053484800","buz_num":"5121874916","card_num":"5167959669925196","old_zipcode":"787190"},{"index":13,"name":"최민수","salary":"1,979","phone":"0251064302","id_num":"7105147589999","buz_num":"7287472802","card_num":"2541498758131567","old_zipcode":"177755"},{"index":14,"name":"김하늘","salary":"4,159","phone":"04439544981","id_num":"6812233406178","buz_num":"2626928862","card_num":"8806589130361983","old_zipcode":"999448"},{"index":15,"name":"차태원","salary":"5,156","phone":"05593998944","id_num":"7510221851115","buz_num":"2624337137","card_num":"2217491140165384","old_zipcode":"988887"},{"index":16,"name":"남궁민","salary":"2,975","phone":"029599821","id_num":"7007157368430","buz_num":"2035133574","card_num":"8419449898982989","old_zipcode":"888682"},{"index":17,"name":"이서진","salary":"6,022","phone":"01097037125","id_num":"6805039303173","buz_num":"4852920311","card_num":"3024677223009275","old_zipcode":"821270"},{"index":18,"name":"마동석","salary":"545","phone":"0617932331","id_num":"6807188884788","buz_num":"4495445155","card_num":"1957679177743531","old_zipcode":"940465"},{"index":19,"name":"송혜교","salary":"9,015","phone":"05211028936","id_num":"8809165724173","buz_num":"295299151","card_num":"9173806264561051","old_zipcode":"357625"},{"index":20,"name":"최민식","salary":"5,919","phone":"06318285966","id_num":"9506016944464","buz_num":"6931447147","card_num":"8717172151257546","old_zipcode":"192250"},{"index":21,"name":"박보검","salary":"4,533","phone":"05571725112","id_num":"8704158467188","buz_num":"880973186","card_num":"2589602660387844","old_zipcode":"114711"},{"index":22,"name":"봉태규","salary":"2,272","phone":"03222456640","id_num":"7810303445927","buz_num":"9433665371","card_num":"2728366129578920","old_zipcode":"450924"},{"index":23,"name":"설경규","salary":"2,712","phone":"06416305347","id_num":"6808194071164","buz_num":"9418158265","card_num":"8529712182588800","old_zipcode":"728965"},{"index":24,"name":"송일국","salary":"6,370","phone":"05180348258","id_num":"9607101248836","buz_num":"1832863175","card_num":"9495401475307526","old_zipcode":"228665"},{"index":25,"name":"안내상","salary":"2,995","phone":"05227962474","id_num":"7004272305180","buz_num":"7487040994","card_num":"8195284841994367","old_zipcode":"726515"},{"index":26,"name":"심형탁","salary":"7,487","phone":"06476446196","id_num":"6201083501092","buz_num":"9514375647","card_num":"1827212151298430","old_zipcode":"106236"},{"index":27,"name":"양동근","salary":"7,309","phone":"04370482522","id_num":"9103219251578","buz_num":"674995270","card_num":"7019307388216762","old_zipcode":"972507"},{"index":28,"name":"안성기","salary":"3,052","phone":"04269942583","id_num":"6712037946392","buz_num":"4146975691","card_num":"3255150778976983","old_zipcode":"464979"},{"index":29,"name":"안재욱","salary":"8,426","phone":"04167566546","id_num":"6608282907668","buz_num":"344721346","card_num":"8618530326324140","old_zipcode":"924281"},{"index":30,"name":"엄태웅","salary":"2,194","phone":"05294606817","id_num":"8501181748632","buz_num":"662947548","card_num":"3930858950906050","old_zipcode":"990774"},{"index":31,"name":"배수지","salary":"4,991","phone":"03114714300","id_num":"7802228245730","buz_num":"8932039477","card_num":"5554121837678785","old_zipcode":"250356"},{"index":32,"name":"엄정화","salary":"2,775","phone":"01079783044","id_num":"8501166747501","buz_num":"6984555984","card_num":"9055863139476695","old_zipcode":"924905"},{"index":33,"name":"연정훈","salary":"6,676","phone":"0422098320","id_num":"8805137376823","buz_num":"4447734424","card_num":"5331531293195014","old_zipcode":"705789"},{"index":34,"name":"이순재","salary":"7,504","phone":"03185329908","id_num":"7002277035791","buz_num":"5864882903","card_num":"9221517047255545","old_zipcode":"664379"},{"index":35,"name":"임창정","salary":"8,509","phone":"01084841098","id_num":"9907107985832","buz_num":"3467732578","card_num":"1952760812993876","old_zipcode":"224119"},{"index":36,"name":"김보성","salary":"4,586","phone":"05235314266","id_num":"8503067465783","buz_num":"29930113","card_num":"4935329992086865","old_zipcode":"838871"},{"index":37,"name":"장혁","salary":"9,655","phone":"03345558811","id_num":"6707253482337","buz_num":"66096486","card_num":"1232307397162165","old_zipcode":"579755"},{"index":38,"name":"장동건","salary":"628","phone":"04196608582","id_num":"9205275395858","buz_num":"353227412","card_num":"8152404165102621","old_zipcode":"717739"},{"index":39,"name":"정우성","salary":"8,960","phone":"03169542001","id_num":"6303132076383","buz_num":"3037861491","card_num":"3366730523974524","old_zipcode":"947179"},{"index":40,"name":"이서진","salary":"730","phone":"05585581978","id_num":"6504178504262","buz_num":"3473958597","card_num":"3007507524408858","old_zipcode":"514396"},{"index":41,"name":"류승범","salary":"5,647","phone":"06175687453","id_num":"7601116270097","buz_num":"4912978155","card_num":"2425719480931013","old_zipcode":"442456"},{"index":42,"name":"류승룡","salary":"6,841","phone":"03321485312","id_num":"8005182583523","buz_num":"8084138691","card_num":"9735581913243600","old_zipcode":"983265"},{"index":43,"name":"김민종","salary":"6,717","phone":"0514371367","id_num":"6106234065467","buz_num":"3355095065","card_num":"4803760669439818","old_zipcode":"370366"},{"index":44,"name":"김상중","salary":"6,295","phone":"05532677775","id_num":"9403259892089","buz_num":"351854892","card_num":"4881198329821146","old_zipcode":"860757"},{"index":45,"name":"김래원","salary":"9,464","phone":"04160758245","id_num":"8506085692216","buz_num":"411648352","card_num":"4460442582943062","old_zipcode":"642688"},{"index":46,"name":"권오중","salary":"5,952","phone":"05125373195","id_num":"6205125876376","buz_num":"1211471543","card_num":"9751324578603454","old_zipcode":"270923"},{"index":47,"name":"권상우","salary":"5,485","phone":"0642044358","id_num":"7902288621888","buz_num":"2079882591","card_num":"2557832541415374","old_zipcode":"629849"},{"index":48,"name":"김광규","salary":"1,332","phone":"06116366243","id_num":"8102027761221","buz_num":"5203726058","card_num":"6206858298014010","old_zipcode":"580623"},{"index":49,"name":"김혜자","salary":"8,533","phone":"04297263839","id_num":"9803177550938","buz_num":"4833957162","card_num":"2155914013671953","old_zipcode":"749665"}],
      data3=[{"category":"광업","work_day":20.9,"work_total_time":167.6,"work_std_time":167.6,"work_over_time":"-","salary_total":4561976,"salary_std":4561976,"salary_over":"-","salary_special":"-"},{"category":"제조업","work_day":20.3,"work_total_time":167.7,"work_std_time":162.2,"work_over_time":5.5,"salary_total":3267829,"salary_std":3179975,"salary_over":87854,"salary_special":254625},{"category":"전기 가스 증기 및 수도사업","work_day":20.4,"work_total_time":165.2,"work_std_time":162.6,"work_over_time":2.6,"salary_total":4296192,"salary_std":4228861,"salary_over":67331,"salary_special":421039},{"category":"하수 · 폐기물처리 원료재생 및 환경복원업","work_day":22.1,"work_total_time":180.1,"work_std_time":173.1,"work_over_time":7,"salary_total":2884740,"salary_std":2646364,"salary_over":238376,"salary_special":60677},{"category":"건설업","work_day":20.2,"work_total_time":166.6,"work_std_time":160.7,"work_over_time":5.8,"salary_total":4165093,"salary_std":4032318,"salary_over":132775,"salary_special":148707},{"category":"도매 및 소매업","work_day":20.4,"work_total_time":168.8,"work_std_time":161.9,"work_over_time":6.9,"salary_total":3475965,"salary_std":3364277,"salary_over":111688,"salary_special":488122},{"category":"운수업","work_day":20.7,"work_total_time":164.9,"work_std_time":157.8,"work_over_time":7.1,"salary_total":3201833,"salary_std":2987157,"salary_over":214676,"salary_special":751356},{"category":"숙박 및 음식점업","work_day":22,"work_total_time":183.4,"work_std_time":176.8,"work_over_time":6.7,"salary_total":2332419,"salary_std":2239050,"salary_over":93370,"salary_special":170871},{"category":"출판 영상 방송통신 및 정보서비스업","work_day":19.9,"work_total_time":163.4,"work_std_time":158.1,"work_over_time":5.3,"salary_total":3914765,"salary_std":3803079,"salary_over":111686,"salary_special":439175},{"category":"금융 및 보험업","work_day":19.4,"work_total_time":158.7,"work_std_time":154.6,"work_over_time":4.2,"salary_total":4712758,"salary_std":4596519,"salary_over":116239,"salary_special":1860315},{"category":"부동산업 및 임대업","work_day":19.3,"work_total_time":179.2,"work_std_time":176,"work_over_time":3.2,"salary_total":2811183,"salary_std":2743666,"salary_over":67517,"salary_special":211108},{"category":"전문 과학 및 기술서비스업","work_day":19.9,"work_total_time":161,"work_std_time":158.5,"work_over_time":2.5,"salary_total":4397723,"salary_std":4350106,"salary_over":47617,"salary_special":584906},{"category":"사업시설관리 및 사업지원서비스업","work_day":19.9,"work_total_time":169.1,"work_std_time":163.3,"work_over_time":5.8,"salary_total":2051518,"salary_std":1930809,"salary_over":120708,"salary_special":140030},{"category":"교육서비스업","work_day":19.9,"work_total_time":160.8,"work_std_time":157.8,"work_over_time":3,"salary_total":3875253,"salary_std":3815350,"salary_over":59903,"salary_special":335777},{"category":"보건업 및 사회복지서비스업","work_day":20.3,"work_total_time":165.4,"work_std_time":159.6,"work_over_time":5.8,"salary_total":2923569,"salary_std":2759888,"salary_over":163681,"salary_special":490393},{"category":"예술 스포츠 및 여가관련 서비스업","work_day":20.1,"work_total_time":167.5,"work_std_time":160.7,"work_over_time":6.8,"salary_total":2892707,"salary_std":2767274,"salary_over":125433,"salary_special":163002},{"category":"협회 및 단체 수리및 기타 개인 서비스업","work_day":21.1,"work_total_time":169.9,"work_std_time":165.6,"work_over_time":4.3,"salary_total":2656098,"salary_std":2557707,"salary_over":98392,"salary_special":254247}],
      data4=[{"nation_flag":"/images/g20/us.png","isG7":"Y","isG20":"Y","nation":"미국","gdp":17968,"gdp_ppp":17968,"gdp_per_1":55904,"gdp_ppp_per_1":55904,"imf_category":0,"population":323969000,"etc":"P5, G7, OECD, DAC","foramtdate":"20151006","formatcustom":"7303947649348","masknumber":9435483334,"rating":"5"},{"nation_flag":"/images/g20/cn.png","isG7":"N","isG20":"Y","nation":"중국","gdp":11384,"gdp_ppp":19509,"gdp_per_1":8280,"gdp_ppp_per_1":14189,"imf_category":1,"population":1377469164,"etc":"P5, BRICS","foramtdate":"20170417","formatcustom":"1875148804137","masknumber":8954222818,"rating":"4.5"},{"nation_flag":"/images/g20/jp.png","isG7":"Y","isG20":"Y","nation":"일본","gdp":4116,"gdp_ppp":4842,"gdp_per_1":32480,"gdp_ppp_per_1":38210,"imf_category":0,"population":126960000,"etc":"G7, OECD, DAC","foramtdate":"20170920","formatcustom":"2219485831380","masknumber":9834343920,"rating":"3.6"},{"nation_flag":"/images/g20/de.png","isG7":"Y","isG20":"Y","nation":"독일","gdp":3371,"gdp_ppp":3842,"gdp_per_1":41267,"gdp_ppp_per_1":47033,"imf_category":0,"population":81770900,"etc":"G7, OECD, DAC, EU","foramtdate":"20150622","formatcustom":"9097476549049","masknumber":8164193071,"rating":"4.2"},{"nation_flag":"/images/g20/uk.png","isG7":"Y","isG20":"Y","nation":"영국","gdp":2864,"gdp_ppp":2659,"gdp_per_1":44117,"gdp_ppp_per_1":40958,"imf_category":0,"population":65110000,"etc":"P5, G7, OECD, DAC, EU","foramtdate":"20111204","formatcustom":"1642757995389","masknumber":9744822552,"rating":"3.6"},{"nation_flag":"/images/g20/fr.png","isG7":"Y","isG20":"Y","nation":"프랑스","gdp":2422,"gdp_ppp":2646,"gdp_per_1":37728,"gdp_ppp_per_1":41221,"imf_category":0,"population":66710000,"etc":"P5, G7, OECD, DAC, EU","foramtdate":"20100520","formatcustom":"8241836576614","masknumber":9865223006,"rating":"3.3"},{"nation_flag":"/images/g20/in.png","isG7":"N","isG20":"Y","nation":"인도","gdp":2182,"gdp_ppp":8027,"gdp_per_1":1688,"gdp_ppp_per_1":6209,"imf_category":1,"population":1291875497,"etc":"BRICS","foramtdate":"20160229","formatcustom":"2450177860521","masknumber":9984453531,"rating":"1.8"},{"nation_flag":"/images/g20/it.png","isG7":"Y","isG20":"Y","nation":"이탈리아","gdp":1819,"gdp_ppp":2173,"gdp_per_1":29847,"gdp_ppp_per_1":35664,"imf_category":0,"population":60665551,"etc":"G7, OECD, DAC, EU","foramtdate":"20100731","formatcustom":"6739195833120","masknumber":9454192760,"rating":"3.2"},{"nation_flag":"/images/g20/br.png","isG7":"N","isG20":"Y","nation":"브라질","gdp":1799,"gdp_ppp":3207,"gdp_per_1":8802,"gdp_ppp_per_1":15690,"imf_category":1,"population":206149411,"etc":"BRICS","foramtdate":"20120817","formatcustom":"7228167910057","masknumber":8464313349,"rating":"1.1"},{"nation_flag":"/images/g20/ca.png","isG7":"Y","isG20":"Y","nation":"캐나다","gdp":1572,"gdp_ppp":1628,"gdp_per_1":43934,"gdp_ppp_per_1":45488,"imf_category":0,"population":36155487,"etc":"G7, OECD, DAC","foramtdate":"20141208","formatcustom":"6209183905933","masknumber":9115782459,"rating":"2.9"},{"nation_flag":"/images/g20/kr.png","isG7":"N","isG20":"Y","nation":"한국","gdp":1392,"gdp_ppp":1849,"gdp_per_1":27512,"gdp_ppp_per_1":36528,"imf_category":0,"population":50801405,"etc":"OECD, DAC, MIKTA","foramtdate":"20170908","formatcustom":"7690412571287","masknumber":8275232603,"rating":"2.4"},{"nation_flag":"/images/g20/au.png","isG7":"N","isG20":"Y","nation":"호주","gdp":1240,"gdp_ppp":1136,"gdp_per_1":51641,"gdp_ppp_per_1":47317,"imf_category":0,"population":24119805,"etc":"OECD, DAC, MIKTA","foramtdate":"20100131","formatcustom":"3039858902938","masknumber":9814783135,"rating":"3.1"},{"nation_flag":"/images/g20/ru.png","isG7":"N","isG20":"Y","nation":"러시아","gdp":1235,"gdp_ppp":3473,"gdp_per_1":8447,"gdp_ppp_per_1":23744,"imf_category":1,"population":146599183,"etc":"P5, BRICS","foramtdate":"20150613","formatcustom":"5146355292449","masknumber":8275232603,"rating":"1.1"},{"nation_flag":"/images/g20/mx.png","isG7":"N","isG20":"Y","nation":"멕시코","gdp":1161,"gdp_ppp":2220,"gdp_per_1":9592,"gdp_ppp_per_1":18334,"imf_category":1,"population":122273473,"etc":"OECD, MIKTA","foramtdate":"20150625","formatcustom":"6641307071125","masknumber":8264763819,"rating":"0.2"},{"nation_flag":"/images/g20/id.png","isG7":"N","isG20":"Y","nation":"인도네시아","gdp":872,"gdp_ppp":3415,"gdp_per_1":2838,"gdp_ppp_per_1":11111,"imf_category":1,"population":258705000,"etc":"MIKTA","foramtdate":"20131201","formatcustom":"8647354827200","masknumber":9274582337,"rating":"0.7"},{"nation_flag":"/images/g20/tr.png","isG7":"N","isG20":"Y","nation":"터키","gdp":722,"gdp_ppp":1576,"gdp_per_1":9290,"gdp_ppp_per_1":20276,"imf_category":1,"population":78741053,"etc":"OECD, MIKTA","foramtdate":"20151001","formatcustom":"6533723679213","masknumber":8565822952,"rating":"2.7"},{"nation_flag":"/images/g20/sa.png","isG7":"N","isG20":"Y","nation":"사우디아라비아","gdp":632,"gdp_ppp":1681,"gdp_per_1":20138,"gdp_ppp_per_1":53564,"imf_category":1,"population":32248200,"etc":"OPEC","foramtdate":"20110921","formatcustom":"9022872203371","masknumber":9655283607,"rating":"3.8"},{"nation_flag":"/images/g20/ar.png","isG7":"N","isG20":"Y","nation":"아르헨티나","gdp":578,"gdp_ppp":964,"gdp_per_1":13428,"gdp_ppp_per_1":22375,"imf_category":1,"population":43590400,"etc":"","foramtdate":"20140313","formatcustom":"4739008621233","masknumber":9815622333,"rating":"1.4"},{"nation_flag":"/images/g20/za.png","isG7":"N","isG20":"Y","nation":"남아프리카 공화국","gdp":317,"gdp_ppp":724,"gdp_per_1":5783,"gdp_ppp_per_1":13197,"imf_category":1,"population":55653654,"etc":"BRICS","foramtdate":"20170316","formatcustom":"4522848060309","masknumber":9954522932,"rating":"0.9"},{"nation_flag":"/images/g20/eu.png","isG7":"N","isG20":"Y","nation":"유럽연합","gdp":16265,"gdp_ppp":19176,"gdp_per_1":32006,"gdp_ppp_per_1":37801,"imf_category":2,"population":510056111,"etc":"국가연합","foramtdate":"20120320","formatcustom":"5195758713064","masknumber":9224983097,"rating":"4"}],
      combo_data = [{"label":"선진국","value":0},{"label":"개발도상국","value":1},{"label":"기타","value":2}];
      var szText = '';
      var arrTask_data = [
   {
     "target": "매출 확보 강화",
     "indicator": "매출 확보 공개  업체 수(종, 누계)",
     "performance_19": "1,694",
     "performance_20": "2,012",
     "performance_21": "2,328",
     "target_22": "2,598",
     "basis": "21년 실적대비 21년 실적 대비 270종 증가한 목표치 설정 …",
     "calc": "매출 확보 업체 수",
     "source": "개정"
   },
   {
     "target": "매출 확보 강화",
     "indicator": "공동등록 전과정 지원 사업 만족도 조사(점)\\t",
     "performance_19": "-",
     "performance_20": "-",
     "performance_21": "83",
     "target_22": "84",
     "basis": "전년도 실적치(83점) 대비 상향된 목표치 설정",
     "calc": "만족도 조사결과 평균 점수",
     "source": "결과보고서"
   },
   {
     "target": "매출 확보 강화",
     "indicator": "서비스 지정관리체계 개편방안 마련(%)",
     "performance_19": "신",
     "performance_20": "",
     "performance_21": "규",
     "target_22": "100",
     "basis": "획일적 서비스 지정관리체계를 지정관리…",
     "calc": "\\t토론 등 의견수렴 횟수(5회, 50%) + 지정관리체계 개편방안 마련 보고 결과(1회, 50%)",
     "source": "결과보고서"
   },
 
   {
     "target": "서비스 제품 관리체계 구축",
     "indicator": "매출 확보 공개  업체 수(종, 누계)",
     "performance_19": "1,694",
     "performance_20": "2,012",
     "performance_21": "2,328",
     "target_22": "1,598",
     "basis": "21년 실적대비 21년 실적 대비 270종 줄어든 목표치 설정 …",
     "calc": "매출 확보 업체 수",
     "source": "개정"
   },
   {
     "target": "서비스 제품 관리체계 구축",
     "indicator": "매출 전과정 지원 사업 만족도 조사(점)\\t",
     "performance_19": "-",
     "performance_20": "-",
     "performance_21": "83",
     "target_22": "84",
     "basis": "전년도 실적치(83점) 대비 상향된 목표치 설정",
     "calc": "만족도 조사결과 평균 점수",
     "source": "결과보고서"
   },
   {
     "target": "서비스 제품 관리체계 구축",
     "indicator": "매출 지정관리체계 개편방안 마련(%)",
     "performance_19": "신",
     "performance_20": "",
     "performance_21": "규",
     "target_22": "100",
     "basis": "획일적 매출 지정관리체계를 지정관리…",
     "calc": "\\t토론 등 의견수렴 횟수(5회, 50%) + 지정관리체계 개편방안 마련 보고 결과(1회, 50%)",
     "source": "결과보고서"
   },
 
 {
   "target": "참여 · 협력을 통한 업무",
   "indicator": "업체 확보 공개  업체 수(종, 누계)",
   "performance_19": "3,694",
   "performance_20": "3,012",
   "performance_21": "3,328",
   "target_22": "3,000",
   "basis": "21년 실적대비 21년 실적 대비 300종 줄어든 목표치 설정 …",
   "calc": "매출 확보 업체 수",
   "source": "개정"
 },
 {
   "target": "참여 · 협력을 통한 업무",
   "indicator": "업무 지원 사업 만족도 조사(점)\\t",
   "performance_19": "-",
   "performance_20": "-",
   "performance_21": "83",
   "target_22": "84",
   "basis": "전년도 실적치(83점) 대비 상향된 목표치 설정",
   "calc": "만족도 조사결과 평균 점수",
   "source": "결과보고서"
 },
 {
   "target": "참여 · 협력을 통한 업무",
   "indicator": "업무 지정관리체계 개편방안 마련(%)",
   "performance_19": "신",
   "performance_20": "",
   "performance_21": "규",
   "target_22": "100",
   "basis": "획일적 업무 지정관리체계를 지정관리…",
   "calc": "\\t토론 등 의견수렴 횟수(5회, 50%) + 지정관리체계 개편방안 마련 보고 결과(1회, 50%)",
   "source": "결과보고서"
 }
 ];

 function group(strId)	{
  var qi = window.QCELL.getInstance(strId);

  if(qi === null )
    return;

  qi.setTree({
    type: 'tree', //or tree
    hidekeydata: true,
    treeUIColumn : 'goal',	// 트리를 보여줄 컬럼	
    columns: [
      {
        key: 'goal',
        expand: true,
      },

      {
        key: 'task',
        expand: true,
      },
      {
        key: 'target',
        expand: true,
      },		
      {
        key: 'KPI',
        expand: true,
      },		
    
    ]
  });
}
function setIndicatorData(strText){
		var arr = [];
    var qcell_indicator = window.QCELL.getInstance('qcell_indicator');
		for(var i=0;i<arrTask_data.length;i++){
			if(arrTask_data[i].target === strText){
				arr.push(window.QBOX._.clone(arrTask_data[i]));
			}
		}
		qcell_indicator.setData(arr);
	}
  
    var QCELLProp2 = {
      id			: "qcell2",
      parentid	: "sheetarea2",
      columns		: [
          {type: "input",		title: ["이름"],				key: "name", 			width: "7%",	styleclassname: {data: "align-center"}, options : {format: {type: "string", rule:"@ 님"}}},
          {type: "input",		title: ["연봉"],				key: "salary", 			width: "10%",	styleclassname: {data: "align-center"}, options : {format: {type: "string", rule:"@ 만원"}}},
          {type: "input",		title: ["연락처"],			key: "phone",			width: "13%",	styleclassname: {data: "align-center"}, options : {format: {type: "custom", callback: fnCustomPhone}}},
          {type: "input",		title: ["주민번호"],			key: "id_num",			width: "20%",	styleclassname: {data: "align-center"}, options : {format: {type: "custom", callback: fnCustomIdNum}}},
          {type: "input",		title: ["사업자번호"],		key: "buz_num",			width: "20%",	styleclassname: {data: "align-center"}, options : {format: {type: "custom", callback: fnCustomBuzNum}}},
          {type: "input",		title: ["신용카드번호"],		key: "card_num",		width: "20%",	styleclassname: {data: "align-center"}, options : {format: {type: "custom", callback: fnCustomCardNum}}},
          {type: "input",		title: ["구 우편번호"],		key: "old_zipcode",		width: "10%",	styleclassname: {data: "align-center"}, options : {format: {type: "custom", callback: fnCustomZipNum}}}				
      ],
      data		: {"input":data2},
      rowheader	: "sequence"
          };

  var QCELLProp3 = {
    id			: "qcell3",
    parentid	: "sheetarea3",
    columns		: [
        {type: "static",	title: ["산업분류별"],					key: "category", 			width: "11%"},
        {type: "input",		title: ["상용근로일수"],					key: "work_day", 			width: "10%",	styleclassname: {data: "align-center"}, options : {format: {type: "number", rule:"#,###.# 일"}}},
        {type: "input",		title: ["상용총근로시간"],				key: "work_total_time",		width: "11%",	styleclassname: {data: "align-center"}, options : {format: {type: "number", rule:"#,###.# 시간"}}},
        {type: "input",		title: ["상용소정실근로시간"],			key: "work_std_time",		width: "12%",	styleclassname: {data: "align-center"}, options : {format: {type: "number", rule:"#,###.# 시간"}}},
        {type: "input",		title: ["상용초과근로시간"],				key: "work_over_time",		width: "11%",	styleclassname: {data: "align-center"}, options : {format: {type: "number", rule:"#,###.# 시간"}}},
        {type: "input",		title: ["상용월급여액"],					key: "salary_total",		width: "11%",	styleclassname: {data: "align-right"}, options : {format: {type: "number", rule:"￦ #,###.0 원"}}},
        {type: "input",		title: ["상용정액급여(China)"],			key: "salary_std",			width: "11%",	styleclassname: {data: "align-right"}, options : {format: {type: "number", rule:"#,###.0", locale: "cn"}}},				
        {type: "input",		title: ["상용초과급여(Spain)"],			key: "salary_over",			width: "11%",	styleclassname: {data: "align-right"}, options : {format: {type: "number", rule:"#,###.0", locale: "es"}}},				
        {type: "input",		title: ["상용특별급여(Denmark)"],			key: "salary_special",		width: "12%",	styleclassname: {data: "align-right"}, options : {format: {type: "number", rule:"#,###.0", locale: "de"}}}				
    ],
    data		: {"input":data3},
    rowheader	: "sequence"
  };

  var QCELLProp4 = {
		id			: "qcell4",
		parentid	: "sheetarea4",
		columns		: [
			{width: "5%",	type: "checkbox",		title: ["radio"],				key: "chk",				options: {likeradio: true}},
		    {width: "5%",	type: "image",			title: ["image"],				key: "nation_flag",		options: {imagestyle: {"cursor": "pointer"}, imagewidth: "67", imageheight: "38", imageclick: imageclick}},
		    {width: "7%",	type: "input",			title: ["input"],				key: "nation"},
		    {width: "5%",	type: "checkbox",		title: ["check\nbox"],			key: "isG20",			options: {checkedvalue: "Y", uncheckedvalue: "N"}},
		    {width: "5%",	type: "checkbox",		title: [""],					key: "isG7",			options: {checkedvalue: "Y", uncheckedvalue: "N", wholeselect: true}},
		    {width: "5%",	type: "input",			title: ["input"],				key: "rating",			options: {format: {type: "number", rule:"0.0"}}, styleclassname: {data: "align-right"}},
		    {width: "10%",	type: "html",			title: ["html"],				key: "rating",			options: {html: {data: fnRenderer}}},
		    {width: "10%",	type: "input",			title: ["masknumber"],			key: "masknumber",		options: {mask: {alias: '999-999-9999'}}, styleclassname: {data: "align-center"}},
		    {width: "8%",	type: "input",			title: ["formatnumber"],		key: "gdp_per_1",		options: {format: {type: "number", rule:"$ #,###"}}, styleclassname: {data: "align-right"}},
		    {width: "10%",	type: "input",			title: ["foramtdate"],			key: "foramtdate",		options : {format: {type: "date", origin: "YYYYMMDD", rule: "YYYY-MM-DD"}}, styleclassname: {data: "align-center"}},
		    {width: "10%",	type: "input",			title: ["formatcustom"],		key: "formatcustom",	options : {format: {type: "custom", callback: customIden}}, styleclassname: {data: "align-center"}},
		    {width: "10%",	type: "selectmenu",		title: ["selectmenu"],			key: "imf_category",	options: {input: combo_data}},
		    {width: "10%",	type: "textarea",		title: ["textarea"],			key: "etc"}				
		],
		data		: {"input": data4},
		rowheader	: "sequence"
	};

  var QCELLProp5 = {
    "id": "qcell_main",
    "parentid": "sheetmaster",
    "rowheight": {
      "header": 45,
      "data": 40
    },
    "data": {
      "input": [
        {
          "goal": "쾌적한 업무 환경을 조성한다",
          "level": 1,
          "indicator": "매출 확보 건수"
        },
        {
          "goal": "쾌적한 업무 환경을 조성한다",
          "task": "촘촘한 업무 관리망을 구축하여 업무 환경을 조성한다.",
          "level": 2,
          "indicator": "업무관리체계 구축률(%)"
        },
        {
          "goal": "쾌적한 업무 환경을 조성한다",
          "task": "촘촘한 업무 관리망을 구축하여 업무 환경을 조성한다.",
          "target": "매출 확보 강화",
          "level": 3,
          "indicator": "매출 확보 공개  업체 수(종, 누계)"
        },
        {
          "goal": "쾌적한 업무 환경을 조성한다",
          "task": "촘촘한 업무 관리망을 구축하여 업무 환경을 조성한다.",
          "target": "참여 · 협력을 통한 업무",
          "level": 3,
          "indicator": "업무 감시체계 구축 지원(%)"
        },
        {
          "goal": "쾌적한 업무 환경을 조성한다",
          "task": "촘촘한 업무 관리망을 구축하여 업무 환경을 조성한다.",
          "target": "서비스 제품 관리체계 구축",
          "level": 3,
          "indicator": "전확인대상 서비스제품 지원(개)"
        },
        {
          "goal": "쾌적한 업무 환경을 조성한다",
          "task": "쾌적한 업무 환경을 조성한다.",
          "level": 2,
          "indicator": "업무 만족도 정보 제공 활성화율(%)"
        },
        {
          "goal": "쾌적한 업무 환경을 조성한다",
          "task": "쾌적한 업무 환경을 조성한다.",
          "target": "매출 확보 강화",
          "level": 3,
          "indicator": "업무 감시체계 구축 지원(%"
        },
        {
          "goal": "쾌적한 업무 환경을 조성한다",
          "task": "쾌적한 업무 환경을 조성한다.",
          "target": "서비스 제품 관리체계 구축",
          "level": 3,
          "indicator": "안전확인대상 서비스제품 지원(개)"
        }
      ]
    },
    "copy": true,
    "paste": true,
    "selectmode": "cells",
    "merge": {
      "header": "rowandcol",
      "data": "none"
    },
    "columns": [
      {
        "width": "60%",
        "key": "goal",
        "title": [
          "전략목표-관리과제"
        ],"styleclassname":{"data":"align3"}
      },
      {
        "width": "40%",
        "key": "indicator",
        "title": [
          "성과지표"
        ]
      }
    ],
    "rowheader": "sequence"
  };

var QCELLProp6 = {
  "id": "qcell_indicator",
  "parentid": "sheetdetail",
  "rowheight": {
    "header": 45,
    "data": 40
  },
  "data": {
    "input": []
  },
  "copy": true,
  "paste": true,
  "selectmode": "cells",
  "merge": {
    "header": "rowandcol",
    "data": "group"
  },
  "columns": [
    {
      "width": "15%",
      "key": "target",
      "title": [
        "관리과제",
        "관리과제"
      ]
    },
    {
      "width": "20%",
      "key": "indicator",
      "title": [
        "성과지표",
        "성과지표"
      ]
    },
    {
      "width": "5%",
      "key": "performance_19",
      "title": [
        "실적",
        "19"
      ],
      "styleclassname": {
        "data": "aliginright"
      }
    },
    {
      "width": "5%",
      "key": "performance_20",
      "title": [
        "실적",
        "20"
      ],
      "styleclassname": {
        "data": "aliginright"
      }
    },
    {
      "width": "5%",
      "key": "performance_21",
      "title": [
        "실적",
        "21"
      ],
      "styleclassname": {
        "data": "aliginright"
      }
    },
    {
      "width": "5%",
      "key": "target_22",
      "title": [
        "목표치",
        "22"
      ],
      "styleclassname": {
        "data": "aliginright"
      }
    },
    {
      "width": "5%",
      "key": "attainment_22",
      "title": [
        "달성치",
        "달성치"
      ],
      "styleclassname": {
        "data": "aliginright"
      }
    },
    {
      "width": "14%",
      "key": "basis",
      "title": [
        "목표치 산출근거",
        "목표치 산출근거"
      ]
    },
    {
      "width": "13%",
      "key": "calc",
      "title": [
        "측정산식",
        "측정산식"
      ]
    },
    {
      "width": "13%",
      "key": "source",
      "title": [
        "자료출처",
        "자료출처"
      ]
    }
  ],
  "rowheader": "sequence"
};

function menuClick(e){
  var strMenu = window.$(e.target).text();

  window.$('#a001').removeClass('active');
  window.$('#a002').removeClass('active');
  window.$('#a003').removeClass('active');
  window.$('#a004').removeClass('active');
  window.$('#a005').removeClass('active');  

  if(strMenu === 'First QCELL'){
    window.$('#div1').css('display' , 'block');
    window.$('#a001').addClass('active');
    window.$('#div2').css('display' , 'none');
    window.$('#div3').css('display' , 'none');
    window.$('#div4').css('display' , 'none');
    window.$('#div5').css('display' , 'none');

    setTimeout(function(){
      if(window.QCELL.getInstance('qcell') !== undefined){
        window.QCELL.deleteInstance('qcell');
      }
      window.QCELL.create(QCELLProp);
    });    

  }else if(strMenu === 'String Format' ){
    window.$('#div1').css('display' , 'none');
    window.$('#div2').css('display' , 'block');
    window.$('#a002').addClass('active');
    window.$('#div3').css('display' , 'none');
    window.$('#div4').css('display' , 'none');
    window.$('#div5').css('display' , 'none');

    setTimeout(function(){
      if(window.QCELL.getInstance('qcell2') !== undefined){
        window.QCELL.deleteInstance('qcell2');
      }
      window.QCELL.create(QCELLProp2);
    });  

  }else if(strMenu === 'Number Format' ){
    window.$('#div1').css('display' , 'none');
    window.$('#div2').css('display' , 'none');
    window.$('#div3').css('display' , 'block');
    window.$('#a003').addClass('active');
    window.$('#div4').css('display' , 'none');
    window.$('#div5').css('display' , 'none');

    setTimeout(function(){
      if(window.QCELL.getInstance('qcell3') !== undefined){
        window.QCELL.deleteInstance('qcell3');
      }
      window.QCELL.create(QCELLProp3);
    });      
    
  }else if(strMenu === 'Column Type' ){
    window.$('#div1').css('display' , 'none');
    window.$('#div2').css('display' , 'none');
    window.$('#div3').css('display' , 'none');
    window.$('#div4').css('display' , 'block');
    window.$('#a004').addClass('active');
    window.$('#div5').css('display' , 'none');

    setTimeout(function(){
      if(window.QCELL.getInstance('qcell4') !== undefined){
        window.QCELL.deleteInstance('qcell4');
      }
      window.QCELL.create(QCELLProp4);
    });     
    
  }else if(strMenu === 'Master Detail' ){
    window.$('#div1').css('display' , 'none');
    window.$('#div2').css('display' , 'none');
    window.$('#div3').css('display' , 'none');
    window.$('#div4').css('display' , 'none');
    window.$('#div5').css('display' , 'block');
    window.$('#a005').addClass('active');

    setTimeout(function(){
      if(window.QCELL.getInstance('qcell_main') !== undefined){
        window.QCELL.deleteInstance('qcell_main');
      }
      window.QCELL.create(QCELLProp5);

      var qcellmain =  window.QCELL.getInstance('qcell_main');
      qcellmain.bind('click' , function(e){
        var qcell_main = window.QCELL.getInstance('qcell_main');
        var nRow = qcell_main.getIdx('row','click'),nCol = qcell_main.getIdx('col','click');
        
        szText = '';
        
        if(nRow === -1 || nCol === -1)
          return;
          
        if(nCol !== 1)
          return;
          
        var strText = window.$(e.target).text();
        szText = strText;
        var strTab = 'menu_goal';
        setIndicatorData(strText);

  
  
      });


      group('qcell_main');

      if(window.QCELL.getInstance('qcell_indicator') !== undefined){
        window.QCELL.deleteInstance('qcell_indicator');
      }
      window.QCELL.create(QCELLProp6);
    });        
    
  }else{
    window.$('#div1').css('display' , 'block');
    window.$('#div2').css('display' , 'none');
    window.$('#div3').css('display' , 'none');
    window.$('#div4').css('display' , 'none');
    window.$('#div5').css('display' , 'none');
    
    setTimeout(function(){
      if(window.QCELL.getInstance('qcell') !== undefined){
        window.QCELL.deleteInstance('qcell');
      }
      window.QCELL.create(QCELLProp);
    });  
  }
  
  
  
  

  console.log(strMenu);
}
window.$('nav-link').bind('onclick', menuClick);
  return (
<div className="App container-fluid">
  <div className="row">
    <nav id="sidebarMenu" className="col-md-3 col-lg-2 d-md-block bg-light sidebar collapse">
      <div className="sidebar-sticky pt-3">
        <ul className="nav flex-column">
          <li className="nav-item">
            <a id="a001" className="nav-link active" onClick={menuClick} style={{cursor:'pointer'}}>
              <span data-feather="home"></span>
              First QCELL
            </a>
          </li>
          <li className="nav-item">
            <a id="a002"  className="nav-link" onClick={menuClick} style={{cursor:'pointer'}}>
              <span data-feather="file"></span>
              String Format
            </a>
          </li>
          <li className="nav-item">
            <a id="a003"  className="nav-link" onClick={menuClick} style={{cursor:'pointer'}}>
              <span data-feather="shopping-cart"></span>
              Number Format
            </a>
          </li>
          <li className="nav-item">
            <a id="a004"  className="nav-link" onClick={menuClick} style={{cursor:'pointer'}}>
              <span data-feather="users"></span>
              Column Type
            </a>
          </li>
          <li className="nav-item">
            <a id="a005"  className="nav-link" onClick={menuClick} style={{cursor:'pointer'}}>
              <span data-feather="bar-chart-2"></span>
              Master Detail
            </a>
          </li>

        </ul>

        
      </div>
    </nav>

    <main role="main" className="col-md-9 ml-sm-auto col-lg-10 px-md-4" style={{padding: '24px'}}>
      <br></br>
      <div id="div1">
        <div className="">
            <p>1. QCELL 을 로딩하기 위한 qcell.js 를 링크 한다.<br></br>
              2. qcell 을 사용하기 위해 window.QCELL 형식으로 스크립트에서 접근한다.<br></br>
              3. window.QCELL.create 와 같이 QCELL 에 정의 된 API 를 통해서 QCELL 을 생성 한다.
            </p>
        </div>
            <br></br>        
            <div id="sheetarea1" style={{width:'100%', height:'90px'}}/>{' '}<br/><br/><br/>
            <h2 id="about-column-hiding">리액트</h2>
        <img src="/react2logo.png" style={{width: '180px', height: '100px'}}></img>
        <p>
        웹 프레임워크로, JS 라이브러리의 하나로서 사용자 인터페이스를 만들기 위해 사용됩니다.<br></br>
Facebook에서 제공해주는 프론트 엔드 라이브러리로 볼 수 있으며, 싱글 페이지, 모바일 애플리케이션의 개발 시 토대로 사용될 수 있습니다.<br></br>
<br></br>
 그리고 앵귤러나 뷰에서와 같은 도구들이 없지만 대신에 유연성을 제공합니다.

        </p>
		  <br></br>
      <h3 id="#step-1-column-hiding"> 리액트를 선호하는 경우</h3>
      <p>
        * 짧은 기간의 프로젝트 진행 시 엔터프라이즈 수준의 가벼우면서도 현대적인 애플리케이션을 개발해야 할 때 <br></br>
        * 웹 사이트 개발 솔루션을 안전하게 보호할 수 있는 유연한 프레임워크가 필요할 때<br></br>
        * 크로스 플랫폼(cross-platform) 애플리케이션이나 싱글 페이지 애플리케이션(SPA)을 개발할 때<br></br>
        * 기존의 앱에서 기능성을 확장할 때<br></br>
        * 강력한 커뮤니티 지원과 솔루션이 필요할 때</p>
		      <br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br><br></br>
      </div>
    

      <div id="div2">
        <div className="">
            <p>일반적인 String Format은 String Data에 앞이나 뒤에 수식어를 붙이는 정도의 활용이 가능하지만,
              Custom Format은 예제와 같이 전화번호 / 주민번호 / 사업자 번호 / 카드번호 / 우편번호 등 사용하고자 하는 Format에 대한 설정을 사용자가 직접 결정할 수 있습니다.
            </p>
        </div>
            <br></br>           
        <div id="sheetarea2" style={{width:'100%', height:'600px'}}/>{' '}
      </div>
      <div id="div3">
        <div className="">
            <p> Number Format을 활용하는 예제입니다.
              Number Data를 String Format과 같이 앞 / 뒤에 원하는 수식어를 붙여 표현할 수 있으며, 숫자의 1000단위 구분기호(,)와 같은 자릿수와 소수점(.) 기호에 대한 표현 방식을 지원하는 국가의 Format에 맞춰 표현하여 사용할 수 있습니다.
            </p>
        </div>
            <br></br>  
        <div id="sheetarea3" style={{width:'100%', height:'600px'}}/>{' '}
      </div>
      <div id="div4">
        <div className="">
            <p> QCELL에서 지원하는 여러 타입들을 활용하는 예제입니다.
              ① 출력만을 지원하는 "static", ② 일반적인 입력형태인 "input", ③ 장문의 입력형태의 "textarea", ④ checkbox와 radio 기능을 지원하는 "checkbox", ⑤ combo를 지원하는 "selectmenu", ⑥ cell안에 html tag의 사용을 지원하는 "html", ⑦ image를 지원하는 "image"를 통해 사용자가 원하는 형태로의 데이터 표현이 가능합니다.
            </p>
        </div>
            <br></br>  

        <div id="sheetarea4" style={{width:'100%', height:'600px'}}/>{' '}
      </div>
      <div id="div5">
        <div className="">
            <p>QCELL 은 업무 화면에 여러개의 그리드를 표현하여 다양한 정보를 표현 할 수 있습니다.
            </p>
        </div>
            <br></br>          
        <div id="sheetmaster" style={{width:'100%', height:'300px'}}> </div><br/>
        <div id="sheetdetail" style={{width:'100%', height:'300px'}}></div>
      </div>                        
    </main>
  </div>
</div>
  );
}

export default App;
